import { parseISO, setMinutes, setSeconds, addMinutes } from "date-fns"

export default function roundTime(dateString: string, interval: number): string {
  const date = parseISO(dateString)
  const minutes = date.getMinutes()
  const roundedMinutes = Math.floor(minutes / interval) * interval

  const adjustedDate =
    minutes % interval === 0
      ? setSeconds(setMinutes(date, roundedMinutes), 0)
      : setSeconds(addMinutes(setMinutes(date, roundedMinutes), interval), 0)

  return adjustedDate.toISOString()
}
